module.exports = __webpack_public_path__ + "img/venus13.d9b56c23.png";